export function Lazy(): MethodDecorator {
  return (
    target: any,
    propertyKey: string | symbol,
    descriptor: PropertyDescriptor
  ) => {
    if (descriptor.set || descriptor.value) {
      return descriptor;
    }

    if (descriptor.get) {
      const func = descriptor.get;

      return {
        get() {
          const newDescriptor = {
            configurable: true,
            get: (function iee() {
              let value: any;

              return function closure(this: any) {
                if (!value) {
                  value = func.call(this);
                }
                return value;
              };
            })(),
          };
          Object.defineProperty(this, propertyKey, newDescriptor);
          return newDescriptor.get.call(this);
        },
      };
    }

    return descriptor;
  };
}
